// removed by extract-text-webpack-plugin
module.exports = {"event-receipt-modal":"event-receipt-modal","modal-fixed-height":"modal-fixed-height","modal-body":"modal-body","event-receipt-image-container":"event-receipt-image-container","event-receipt-image":"event-receipt-image"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/modals/component/event-receipt-modal/event-receipt-modal.style.sass
// module id = 0LRl
// module chunks = 0